import { createAction } from 'redux-actions';

// Action for marking the loading of the page to show the spinner.
// Payload is a boolean value true for loading, false for not
export const markPageLoading = createAction('MARK_PAGE_LOADING');

export default {
  markPageLoading,
};
